export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'versionNo',
    align: 'left',
    width: 200,
    title: that.$l('form_label_versionNo') || '版本号',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'versionNumber',
    align: 'left',
    width: 140,
    title: that.$l('form_label_versionNumber') || '版本序号',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'publishTime',
    align: 'center',
    width: 150,
    title: that.$l('form_label_publishTime') || '发布时间',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'publishDescription',
    align: 'left',
    minWidth: 450,
    title: that.$l('form_label_publishDescription') || '发布说明',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'versionStatus',
    align: 'center',
    width: 100,
    title: that.$l('form_label_versionStatus') || '版本状态',
    slots: { default: 'status' },
    showHeaderOverflow: 'title',
  },
  {
    field: 'createTime',
    title: that.$l('INDEX.create_date') || '创建时间',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createByName',
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
